import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
const enrolledCourses = [{
  name: 'Mastering Agency Agreements',
  creditType: '3 hrs. Agency Law',
  status: 'in_progress',
  dateEnrolled: '11/09/2025'
}, {
  name: 'The Bottom Line of Disclosure',
  creditType: '3 hrs. Disclosure',
  status: 'in_progress',
  dateEnrolled: '07/27/2025'
}, {
  name: 'Avoid The Oops: Contract Smarts for Agents',
  creditType: '3 hrs. Contract Law',
  status: 'in_progress',
  dateEnrolled: '07/02/2025'
}, {
  name: 'BMC #3B Property Management',
  creditType: '3 hrs. Req. For Licensees',
  status: 'section_progress',
  dateEnrolled: '07/02/2025'
}, {
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: '3 hrs. Req. For Licensees',
  status: 'section_progress',
  dateEnrolled: '06/22/2025'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  creditType: '3 hrs. General',
  status: 'in_progress',
  dateEnrolled: '05/12/2025'
}, {
  name: 'Accidental Property Management',
  creditType: '3 hrs. Legal Issues',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'BMC #3 AZ Residential-Broker Supervision',
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'BMC #2 AZ Residential-Broker Policies',
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'BMC #1 AZ Residential-Statutes and Rules',
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: "Don't Lose Your License",
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'A Letter From ADRE',
  creditType: '3 hrs. Req. For Licensees',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'Client or Customer Representation',
  creditType: '3 hrs. Agency Law',
  status: 'in_progress',
  dateEnrolled: '05/10/2025'
}, {
  name: 'Are They Represented?',
  creditType: '3 hrs. Agency Law',
  status: 'in_progress',
  dateEnrolled: '02/20/2025'
}, {
  name: 'What Goes Wrong In Contracts',
  creditType: '3 hrs. Contract Law',
  status: 'in_progress',
  dateEnrolled: '08/13/2024'
}, {
  name: 'Follow All The Laws',
  creditType: '3 hrs. Legal Issues',
  status: 'in_progress',
  dateEnrolled: '08/13/2024'
}, {
  name: 'They Are A Protected Class',
  creditType: '3 hrs. Fair Housing',
  status: 'in_progress',
  dateEnrolled: '05/08/2024'
}, {
  name: 'Your Clients Are Not Mushrooms',
  creditType: '3 hrs. Disclosure',
  status: 'in_progress',
  dateEnrolled: '03/03/2023'
}, {
  name: "Fair Housing In Today's World",
  creditType: '3 hrs. Fair Housing',
  status: 'in_progress',
  dateEnrolled: '03/03/2023'
}, {
  name: 'How Contracts Work',
  creditType: '3 hrs. Contract Law',
  status: 'in_progress',
  dateEnrolled: '03/03/2023'
}, {
  name: 'The Owner Is In Default',
  creditType: '3 hrs. Legal Issues',
  status: 'in_progress',
  dateEnrolled: '03/03/2023'
}, {
  name: 'NAR Code of Ethics (NO CE CREDIT)',
  creditType: 'NONE',
  status: 'in_progress',
  dateEnrolled: '01/30/2022'
}, {
  name: 'Fair Housing Facts',
  creditType: '3 hrs. Fair Housing',
  status: 'in_progress',
  dateEnrolled: '02/24/2020'
}, {
  name: 'No Secrets',
  creditType: '3 hrs. Disclosure',
  status: 'in_progress',
  dateEnrolled: '12/15/2017'
}];
export function MyClasses() {
  return <div className="space-y-4" data-id="element-2258" data-mp="3feq68ah9rpj2">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2259" data-mp="qpjisv5ueqgz">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2260" data-mp="up0p1qt3frn7">
          My Classes
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2261" data-mp="t9ya5oo7h4mz">
          Track your currently enrolled courses and continue where you left off.
        </p>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2262" data-mp="1385en81b5u83">
        <div className="overflow-x-auto" data-id="element-2263" data-mp="1359hhlxab9kp">
          <table className="w-full text-sm text-left" data-id="element-2264" data-mp="y89jlyal9d4o">
            <thead style={{
            backgroundColor: '#4A2D8F'
          }} className="text-white font-medium" data-id="element-2265" data-mp="yavrjz1e5unf">
              <tr data-id="element-2266" data-mp="178o8t8qobcdg">
                <th className="px-4 py-3 border-r border-purple-700" data-id="element-2267" data-mp="1774tplgr77d9">Class</th>
                <th className="px-4 py-3 border-r border-purple-700 w-56 whitespace-nowrap" data-id="element-2268" data-mp="1lxkfb1d30hby">
                  Credit Type
                </th>
                <th className="px-4 py-3 border-r border-purple-700" data-id="element-2269" data-mp="1uys3gqlvw1sb">Status</th>
                <th className="px-4 py-3 w-32" data-id="element-2270" data-mp="1uwp95udp7mhs">Date Enrolled</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-2271" data-mp="1qvdirmn02x8j">
              {enrolledCourses.map((course, i) => <tr key={i} className="hover:bg-purple-50/20" data-id="element-2272" data-mp="2eklg1u66kwub" data-mpi={i}>
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-2273" data-mp="2ejsklpco9trh">
                    <Link to={`/student/class/${course.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`} className="text-blue-600 hover:underline text-left" data-id="element-2274" data-mp="20jr9lh2p15ya">
                      {course.name}
                    </Link>
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-slate-700" data-id="element-2275" data-mp="1hvm7ee1opt1l">
                    {course.creditType}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-slate-700" data-id="element-2276" data-mp="17w52hyu9bj6o">
                    {course.status === 'section_progress' ? <span data-id="element-2277" data-mp="1cuoscabz1f4b">Section in progress</span> : <span data-id="element-2278" data-mp="3elfigrkmk22y">
                        Course in progress{' '}
                        <Link to={`/student/class/${course.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}/final-exam`} className="text-blue-600 hover:underline whitespace-nowrap" data-id="element-2279" data-mp="39t5kqpd9pxq4">
                          (Take the final exam)
                        </Link>
                      </span>}
                  </td>
                  <td className="px-4 py-2.5 text-slate-700" data-id="element-2280" data-mp="3ohijfu3qpuob">
                    {course.dateEnrolled}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}